import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map, take } from 'rxjs';

import { TopbarService } from '../services/topbar.service';

export const canViewWorkloadGuard: CanActivateFn = () => {
  const router = inject(Router);
  return inject(TopbarService).canView$.pipe(
    take(1),
    map((flags) => flags.canViewWorkload || router.createUrlTree(['/not-found'])),
  );
};
